import React, { Fragment } from "react";
import StatusMessage from "../../../presentational/StatusMessage";
import { ACCTS } from "../../../../constants/StatusMessages";
import useAccounts from "assets/scripts/hooks/useAccounts";
export const AccountLoadStatus = ({ loading, error }) => (<Fragment>
		<StatusMessage isLoad isActive={loading}/>
		<StatusMessage isError isActive={error != null} error={error} customMessage={ACCTS.INTRO_ACCTS} domain="accts"/>
	</Fragment>);
const WithAccounts = ({ children }) => {
    const accts = useAccounts();
    return children(accts);
};
export default WithAccounts;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/WithAccounts/WithAccounts.tsx